import create from 'zustand';

type Store = {
  isDroped: boolean;
  dropToggle: () => void;
  dropClose: () => void;
};

/**
 * 詳細検索ボックスの開閉状態管理ストア
 */
const useDrop = create<Store>(set => ({
  isDroped: false,
  dropToggle: () => set(state => ({ isDroped: !state.isDroped })),
  dropClose: () => set({ isDroped: false }),
}));

export default useDrop;